import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';

const NavContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #000000;
  border-top: 1px solid #333333;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 8px;
  z-index: 1000;
  padding-bottom: env(safe-area-inset-bottom);

  @media (min-width: 768px) {
    max-width: 414px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const NavButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: transparent;
  border: none;
  color: ${props => props.$isActive ? '#a855f7' : '#ffffff'};
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
  flex: 1;
  min-height: 56px;
  position: relative;

  &:hover {
    background: #111111;
  }

  &:active {
    transform: scale(0.98);
  }

  ${props => props.$isActive && `
    border: 1px solid #333333;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 3px;
      background: #a855f7;
      border-radius: 0 0 3px 3px;
    }
  `}
`;

const NavIcon = styled.i`
  font-size: 20px;
  color: inherit;
`;

const NavLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: inherit;
`;

const InvestorPWABottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/investor-pwa/dashboard');
  const isFeedback = location.pathname.startsWith('/investor-pwa/feedback');
  const isAnnouncements = location.pathname.startsWith('/investor-pwa/announcements');

  return (
    <NavContainer>
      <NavButton
        $isActive={isDashboard}
        onClick={() => navigate('/investor-pwa/dashboard')}
        aria-label="Dashboard"
      >
        <NavIcon className="fas fa-chart-pie" />
        <NavLabel>Dashboard</NavLabel>
      </NavButton>
      <NavButton
        $isActive={isFeedback}
        onClick={() => navigate('/investor-pwa/feedback')}
        aria-label="Feedback"
      >
        <NavIcon className="fas fa-comment-dots" />
        <NavLabel>Feedback</NavLabel>
      </NavButton>
      <NavButton
        $isActive={isAnnouncements}
        onClick={() => navigate('/investor-pwa/announcements')}
        aria-label="Announcements"
      >
        <NavIcon className="fas fa-bullhorn" />
        <NavLabel>Announcements</NavLabel>
      </NavButton>
    </NavContainer>
  );
};

export default InvestorPWABottomNav;
